module.exports = __webpack_public_path__ + "img/cover.c317b637.jpg";